<mat-card class="h-100">
  <mat-card-content style="min-height: 460px">
    <h4 class="mb-20 fw-bold">{{'SCHOOL_PROGRAM_PARTICIPANT_CHART'|translate}}</h4>
    <div class="max-width">
        <div class="form-group row">
            <div class="col-md-4">
                <app-select-school-level-relation-v2 (schoolLevelRelationChanged)="onChangeSchoolLevelRelation($event)"
                                                     [academic_year]="academic_year"
                                                     [all]="false"
                                                     [isDisabled]="!academic_year">
                </app-select-school-level-relation-v2>
            </div>

            <div class="col-md-4">
                <app-select-school-program
                        [isDisabled]="!paramForm.get('school_location_id')?.value"
                        [school_location_id]="paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event)">

                </app-select-school-program>
            </div>
        </div>
        <div *ngIf="!hasData && !loading"  class="d-flex justify-content-center align-items-center mt-5 mb-5" style="height:30vh">
            <h3>{{'NO_DATA_AVAILABLE'|translate}}</h3>
        </div>
        <div *ngIf="!hasData && loading" class="d-flex justify-content-center align-items-center mb-5" style="margin-top: 50px">
            <mat-spinner></mat-spinner>
        </div>
        <div *ngIf="hasData">
            <apx-chart [series]="activityParticipant.series" [dataLabels]="activityParticipant.dataLabels"
                       [chart]="activityParticipant.chart" [legend]="activityParticipant.legend"
                       [xaxis]="activityParticipant.xaxis" [grid]="activityParticipant.grid"
                       [stroke]="activityParticipant.stroke" [tooltip]="activityParticipant.tooltip"
                       [plotOptions]="activityParticipant.plotOptions">
            </apx-chart>
        </div>
    </div>
  </mat-card-content>
</mat-card>
